import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
export var isIterable = function isIterable(x) {
  return x != null && typeof x[Symbol.iterator] === "function";
};